import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "mentions",
  standalone: false
})
export class MentionsPipe implements PipeTransform {
  transform(value: string, nominativeMap: Record<string, string>) {
    if (!value) {
      return "";
    }

    return value
      .split(" ")
      .map((token) => {
        if (token.startsWith("@") && nominativeMap[token.substring(1)]) {
          return `<span class="text-blue-600 font-light"><a href="#">@${
            nominativeMap[token.substring(1)]
          }</a></span>`;
        }

        return token;
      })
      .join(" ");
  }
}
